/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { BannerType } from "./banner-type";

/**
 *
 * @export
 * @interface SiteBanner
 */
export interface SiteBanner {
  /**
   *
   * @type {BannerType}
   * @memberof SiteBanner
   */
  type: BannerType;
  /**
   *
   * @type {string}
   * @memberof SiteBanner
   */
  text: string;
}
